var _path, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 1.30412H11.9V0H10.5V1.30412H3.5V0H2.1V1.30412H1.4C0.63 1.30412 0 1.89098 0 2.60825V13.0412C0 13.7585 0.63 14.3454 1.4 14.3454H12.6C13.37 14.3454 14 13.7585 14 13.0412V2.60825C14 1.89098 13.37 1.30412 12.6 1.30412ZM12.6 13.0412H1.4V4.56443H12.6V13.0412Z",
    fill: "#255986"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7.49219,
    x2: 11,
    y2: 7.49219,
    stroke: "#255986",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9.91016,
    x2: 11,
    y2: 9.91016,
    stroke: "#255986",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 5.80469,
    x2: 5.25,
    y2: 11.6111,
    stroke: "#255986",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.75,
    y1: 5.80469,
    x2: 8.75,
    y2: 11.6111,
    stroke: "#255986",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBase);
export default __webpack_public_path__ + "static/media/calendar_base.5e0ae53fcf3589cc04f99045c7d115eb.svg";
export { ForwardRef as ReactComponent };